export default function KnowledgeIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_4565_6380'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4565_6380)'>
        <path
          d='M12.0006 19.8471L5.50056 16.3164V10.8934L2.03906 9.00112L12.0006 3.57812L21.9621 9.00112V16.1934H20.4621V9.83187L18.5006 10.8934V16.3164L12.0006 19.8471ZM12.0006 12.7011L18.8411 9.00112L12.0006 5.30112L5.16006 9.00112L12.0006 12.7011ZM12.0006 18.1396L17.0006 15.4396V11.6934L12.0006 14.4224L7.00056 11.6934V15.4396L12.0006 18.1396Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
